import { useState,useEffect} from "react";
import { useParams } from "react-router-dom";
import { useAddress} from "@thirdweb-dev/react";

import { lensClient } from "../client/LensClient";
import { isRelaySuccess } from "@lens-protocol/client";
import { ethers } from "ethers";
import { uploadIpfs } from "../ipfs";
import { toast} from 'react-toastify';
import { v4 as uuidv4 } from "uuid";
import { TailSpin } from "react-loader-spinner";

export default function Post(){

  const {id} = useParams();
  const ide = id;
  const address = useAddress();

  const [formInput, setFormInput] = useState({
        title:"",
        description:"",
        content:"",
        media:null,
      });

  const provider = new ethers.providers.Web3Provider(window.ethereum);
  const signer = provider.getSigner();
      // v1 method for creating a post

//       useEffect(()=>{
//         async function post(){
//           if(data){ 
//           const result = data.createPostTypedData;
//           const typedData = result.typedData;
//           if (!sdk) return;
//           //Sign the typed data using the SDK
//           const signature = await signTypedDataWithOmmittedTypename(sdk,typedData.domain, typedData.types, typedData.value)
//           const { v, r, s } = splitSignature(signature.signature);
//           //Send the typed data to the smart contract to perform the
//           // write operation on the blockchain
//           const lensHubContract = await sdk.getContractFromAbi(
//             LENS_CONTRACT_ADDRESS,
//             LENS_CONTRACT_ABI
//           );
//           // Destructure the stuff we need out of the typedData.value field
//           const {
//             collectModule,
//             collectModuleInitData,
//             contentURI,
//             deadline,
//             profileId,
//             referenceModule,
//             referenceModuleInitData,
//             } = typedData.value;
//             // Call the smart contract function called "followWithSig"
//           const tx = await lensHubContract.call("postWithSig",{
//             profileId: profileId,
//             contentURI: contentURI,
//             collectModule,
//             collectModuleInitData,
//             referenceModule,
//             referenceModuleInitData,
//             sig: {
//               v,
//               r,
//               s,
//               deadline: deadline,
//             },
//           });
//           toast.info("Post Created Successfully.",{
//             position:toast.POSITION.TOP_CENTER
//            })
//       }
//     else{
//         console.log("no data");
//     }
//     }
//     post();
// })

    const UploadMedia = async()=>{
        const fileInput = document.getElementById('media');
        const fileCID = await uploadIpfs(fileInput.files[0]);
        if(fileCID){
          toast.success("File Uploaded Successfully.", {
          position: toast.POSITION.TOP_CENTER
        });
      }
        const url = `https://ipfs.io/ipfs/${fileCID}`
      setFormInput({
        ...formInput,
        media: url
      })
    }

    const postMetadata = (
      JSON.stringify({
      version: "2.0.0",
      mainContentFocus: "Image",
      metadata_id: uuidv4(),
      description: formInput.description,
      locale: "en-US",
      content: formInput.content,
      external_url: formInput.media,
      image: formInput.media,
      imageMimeType: null,
      name: formInput.title,
      attributes: [],
      media:[{item:formInput.media}],
      tags: [],
    })
    );

    async function uploadMetadata(){
      const metaCID = await uploadIpfs(postMetadata);
      return `'ipfs://${metaCID}`
    }
      
      // const [createPostTypedData, {data,loading,error}] = useMutation(
      //   CREATE_POST,
      //   {
      //     onCompleted: () => {
      //       console.log("post created");
      //     },

      //     onError: (error) => {
      //       console.log("post error", error);
      //     },
      //   }
      // );
      

      async function HandlePost(){    
        if (formInput.title==="") {
          toast.warn("Title Field is Empty!!",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else if (formInput.description==="") {
          toast.warn("Description Field is Empty!!",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else if (formInput.content==="") {
          toast.warn("Content Field is Empty!!",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else if (!formInput.media) {
          toast.warn("Please include some media for your post.",{
            position:toast.POSITION.TOP_CENTER
          })
        }
        else{
          const postMetadataIpfsUrl = await uploadMetadata();
          console.log("postMetadataIpfsUrl", postMetadataIpfsUrl);

          const { id:authID, text } = await lensClient.authentication.generateChallenge({
            signedBy:address,
            for: id, // e.g "0x01"
          });
          const signature = await signer.signMessage(text); // text returned from authentication.generateChallenge
          await lensClient.authentication.authenticate({ id:authID, signature:signature});
         
          // your LensClient instance must be authenticated

          // the client instance must be authenticated

        const resultTypedData = await lensClient.publication.createOnchainPostTypedData({
          contentURI: postMetadataIpfsUrl, // or arweave
        });

        const { id:dataId, typedData } = resultTypedData.unwrap();

        // sign with the wallet
        const signedTypedData = await signer._signTypedData(typedData.domain, typedData.types,typedData.value,);


        const broadcastResult = await lensClient.transaction.broadcastOnchain({id:dataId,signature: signedTypedData,});

        const broadcastValue = broadcastResult.unwrap();

        if (!isRelaySuccess(broadcastValue)) {
          toast.info("Something went wrong",{
            position:toast.POSITION.TOP_CENTER
          })
          console.log(`Something went wrong`, broadcastValue)
          return
        }

        toast.success("Post Created Successfully",{
          position:toast.POSITION.TOP_CENTER
        })
      }
    }
    return(
        <div className="box">
             <div className="publishform">
                <div className="name-div">
                    <p>Title</p>
                <input name="title" onChange={
                    (prop) => setFormInput({
                        ...formInput,
                        title: prop.target.value
                    })
                    } placeholder="Title" required/>
                </div>
              <div className="name-div">
                <p>Description</p>
                <input name="bio" onChange={
                    (prop) => setFormInput({
                      ...formInput,
                      description: prop.target.value
                    })
                  } placeholder="Description" required/>
              </div>
              <div className="name-div">
                <p>Content</p>
                <input name="content" onChange={
                    (prop) => setFormInput({
                      ...formInput,
                      content: prop.target.value
                    })
                  } placeholder="Content" required/>
              </div>
            <div className="Upload">
            <div className="cover-div">
                <p>Media</p>
                <div className="dotted-div">
                  <div className="top">
                    <input className="uploadCover" type="file" id="media" onChange={UploadMedia} />
                  </div>
                </div>
              </div>
            </div>
            <div className="btn">
              <button className="submit" onClick={HandlePost}>Submit</button>
            </div>
        </div>
        </div>
    );
}